import { render, staticRenderFns } from "./Curriculo_Formacao.vue?vue&type=template&id=162c8ce4&scoped=true"
import script from "./Curriculo_Formacao.vue?vue&type=script&lang=js"
export * from "./Curriculo_Formacao.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Curriculo_Formacao.vue?vue&type=style&index=1&id=162c8ce4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162c8ce4",
  null
  
)

export default component.exports